import API from '../../api';

const types = {
  GET_FLIGHTS_SUCCESS: 'GET_FLIGHTS_SUCCESS',
  GET_FLIGHTS_ERROR: 'GET_FLIGHTS_ERROR',
}

const state = {
  all: []
}

const getters = {
  byId: state => id => {
    return state.all.find(item => item.id == id);
  },
}

const actions = {
  get({ commit }, params) {
    return API.flights.get(params).then(response => {
      commit(types.GET_FLIGHTS_SUCCESS, response.data.result);
      return response;
    }).catch(error => {
      commit(types.GET_FLIGHTS_ERROR);
    });
  },
}

const mutations = {
  [types.GET_FLIGHTS_SUCCESS](state, flights) {
    state.all = flights;
  },

  [types.GET_FLIGHTS_ERROR](state) {
    state.all = [];
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
